import { Navigate, Outlet } from 'react-router-dom';

function ProtectedRoute() {
  const isAuthenticated = sessionStorage.getItem('nbmtm_authenticated') === 'true';

  return isAuthenticated ? <Outlet /> : <Navigate to="/nbmtmops" replace />;
}

export default ProtectedRoute; 